import React, { useRef, useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TravelerTemplateWidget = ({ selectedLayout, isTemplateId, widgetId, numberCounterTabData }) => {
  const { is_website_frontend } = numberCounterTabData || {};
  const mainSliderRef = useRef(null);
  const thumbSliderRef = useRef(null);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/photo-gallery/temp-css/PhotoGallery.css`;
        if (widgetId) {
          link.setAttribute("photo-gallery-data-dynamic-css", "photo-gallery");
        } else {
          link.setAttribute("data-dynamic-css", "photo-gallery");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="photo-gallery"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

  useEffect(() => {
    setNav1(mainSliderRef.current);
    setNav2(thumbSliderRef.current);
  }, []);

  const images = [
    `${process.env.PUBLIC_URL}/photo-gallery/templates/traveler/image.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/traveler/image-1.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/traveler/image-2.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/traveler/image-3.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/traveler/image-4.png`,
    `${process.env.PUBLIC_URL}/photo-gallery/templates/traveler/image-5.png`
  ];

  const mainSettings = {
    asNavFor: nav2,
    ref: mainSliderRef,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 4000,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
  };

  const thumbSettings = {
    asNavFor: nav1,
    ref: thumbSliderRef,
    slidesToShow: 5,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: true,
    dots: false,
    infinite: false,
  };

  return (
    <div className={`upgadeify photo_gallery traveler-temp ${is_website_frontend}`}>
      <div className="photo_gallery__widget">
        <h2>My Big Adventure</h2>
        <div className="traveler-temp__content">
          <Slider {...mainSettings} className="main-slider">
            {images.map((img, i) => (
              <div key={i}>
                <img src={img} alt={`Slide ${i}`} className="main-image" />
              </div>
            ))}
          </Slider>

          <div className="thumbnail-container">
            <Slider {...thumbSettings} className="thumbnail-slider">
              {images.map((img, i) => (
                <div key={i}>
                  <img src={img} alt={`Thumb ${i}`} className="thumbnail" />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelerTemplateWidget;
